import { createSlice } from '@reduxjs/toolkit';

const initialState = { addressResults: {} };

const addressResultsSlice = createSlice({
  name: 'addressResults',
  initialState,
  reducers: {
    setAddressResults: (state, action) => {
      state.addressResults = action.payload;
    },

    resetAddressResults: () => initialState,
  },
});

export const { setAddressResults, resetAddressResults } = addressResultsSlice.actions;
export default addressResultsSlice.reducer;
